<template src="./template.html"/>
<style scoped src="./stylesheet.scss" lang="scss"/>

<script>
    import ShopCard from "../../components/ShopCard/ShopCard";
    import axios from 'axios';

    export default {
        name: "CategoryDetails",
        components: {
            ShopCard
        },
        data() {
            return {
                stores: null,
                categoryName: '',
                error: ''
            }
        },
        mounted() {
            // Get all stores by category
            axios({
                method: "GET",
                "url": '/category/' + this.$route.params.categoryid,
                data: {}
            }).then((response) => {
                this.categoryName = response.data.name;
                this.stores = response.data.stores;
            }).catch((error) => {
                this.error = error.response.data;
                this.$bvModal.show('error-modal');
            });
        },
        methods: {
            backToHome() {
                this.$router.go(-1);
            }
        }
    }
</script>
